<template>
  <div class="mb-5" v-if="$whitelabel.showPromoNotification">
    <b-notification type="is-primary" aria-close-label="Close notification" v-if="!reductionInfo.hasActiveReduction">
      <div class="columns is-vcentered m-0">
        <div class="column is-7-desktop">
          <h4 class="title is-size-4 is-7-tablet is-9-desktop">Sie sind ein braves Mitglied?</h4>
          <p class="subtitle">Lösen Sie Ihren Promotioncode hier ein und erhalten Sie Ihren ADAC-Mitgliederrabatt auf den Normalpreis!</p>
        </div>
        <div class="column has-text-right is-5-tablet is-3-desktop is-offset-2-desktop">
          <b-button type="is-primary" size="is-medium" class="u-w100 is-uppercase" @click="isCodeModalActive = true" inverted outlined>Code einlösen!</b-button>
        </div>
      </div>
    </b-notification>
    <b-modal :active.sync="isCodeModalActive" :width="400" scroll="keep">
      <div class="card">
        <div class="card-header">
          <p class="card-header-title">Code einlösen!</p>
        </div>
        <div class="card-content">
          <div class="content">
            <!-- <b-field label="E-Mail" label-position="inside">
              <b-input placeholder="E-Mail Adresse"></b-input>
            </b-field>-->
            <b-field label="Code" @keyup.native.enter="checkReduction" label-position="inside" :type="{'is-danger': invalidPromotion && promoCode}" :message="[{'Promotioncode ungültig!': invalidPromotion && promoCode}]">
              <b-input v-model="promoCode" placeholder="Code" @input="promotionCodeInput"></b-input>
            </b-field>
            <b-button type="is-primary" class="u-w100 is-uppercase" @click="checkReduction">Code einlösen</b-button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'

export default {
  name: 'PromotionModal',
  props: {},
  computed: {
    ...mapGetters({
      reductionInfo: 'displayReduction',
      invalidPromotion: 'invalidPromotion',
    }),
  },
  data() {
    return {
      isCodeModalActive: false,
      promoCode: null,
    }
  },
  methods: {
    ...mapActions({
      addCode: 'applyReduction',
    }),
    async checkReduction() {
      if (this.promoCode && this.promoCode.length > 0) {
        await this.addCode(this.promoCode)
        if (!this.invalidPromotion) {
          this.isCodeModalActive = false
        }
      }
    },
    promotionCodeInput() {
      if (this.promoCode && this.invalidPromotion) {
        this.$store.dispatch('clearInvalidReduction')
      }
    },
  },
}
</script>
